export function isSafeExternalUrl(url: string | null | undefined): boolean {
  const trimmed = url?.trim()
  if (!trimmed) return false

  try {
    const parsed = new URL(trimmed)
    return parsed.protocol === "http:" || parsed.protocol === "https:"
  } catch {
    return false
  }
}

export function openSafeExternalUrl(url: string, open: typeof window.open = window.open): boolean {
  if (!isSafeExternalUrl(url)) return false
  open(url, "_blank", "noopener,noreferrer")
  return true
}
